import { Switch } from "@mui/material";
// ToggleSection.js (you can also inline this at the top of your file)
const ToggleSection = ({
  id,
  checked,
  onChange,
  title,
  description,
  children,
  styles,
  switchSx
}) => (
  <div className={styles.toggleCard}>
    <div className={styles.toggleHeader}>
      <Switch
        id={id}
        checked={checked}
        onChange={onChange}
        size="small"
        sx={switchSx}
      />
      <label htmlFor={id} className={styles.toggleLabel}>
        <span className={styles.toggleTitle}>{title}</span>
        <span className={styles.toggleDescription}>{description}</span>
      </label>
    </div>

    {checked && children && (
      <div className={styles.toggleContent}>
        {children}
      </div>
    )}
  </div>
);
export default ToggleSection;